"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PhoneLabel_1 = require("../../components/PhoneLabel");
PhoneLabel_1.PhoneLabel.each('.phone-label');
